import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const HomeRedirect = () => {
    const { role } = useSelector((state) => state.auth);
    const storedRole = typeof window !== 'undefined' ? localStorage.getItem('user_role') : null;
    const effectiveRole = role || storedRole;

    if (effectiveRole === 'employee') {
        return <Navigate to="/tasks" replace />;
    }
    return <Navigate to="/vacancy-requests" replace />;
};

export default HomeRedirect;


